import React from "react";
import { Link as NBLink } from "native-base";
import { WithHighlight } from "../hoc";
import { mergeRefs } from "native-base/src/utils";

const linkFactory = function() {
    class Link extends React.Component {

        setRef = (node) =>{
            mergeRefs([this.props.forwardedRef])(node);
            if (!this.props.target || !node) return;
            node.target = this.props.target;
        }

        render() {
            const { href, label, active, onClick, children, className, _text = {}, forwardedRef, target, ...others } = this.props;


            const props = {
                href: href?.startsWith?.("?") ? new URL(href, window.location.href) : href,
                _text,
                active,
                onClick,
                children,
            }


            return <NBLink { ...others } { ...props } ref={this.setRef} color={_text.color}>
                { label }
                { children }
            </NBLink>
        }
    }
    
    return React.forwardRef((props, ref) => {
        return <Link { ...props } forwardedRef={ref} />
    })
}
export const Link = WithHighlight(linkFactory())